import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { Col, Grid, Row } from 'react-bootstrap';

import { AppConstants } from '../../../constants';
import { ILoanAccount } from '../../../interfaces';
import { Card, EditableCard } from '../../../lib/mighty-fields';
import { SessionStoreClass } from '../../../stores';

import { ILoanAccountFormData } from '../leadSource';
import { FIELD_SETS_ACCOUNT_INFO } from './FieldSets';

const { PERMISSIONS } = AppConstants;

interface IProps {
  loanAccount: ILoanAccount;
  onSave: (data: ILoanAccountFormData) => Promise<void>;
}

interface IInjected extends IProps {
  SessionStore: SessionStoreClass;
}

@inject('SessionStore')
@autoBindMethods
@observer
class TabDetails extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  private renderAccountInfo () {
    const { loanAccount, onSave } = this.props
      , { SessionStore } = this.injected
      , cardProps = { fieldSets: FIELD_SETS_ACCOUNT_INFO, model: loanAccount, title: 'Account Info' }
      ;

    // The endpoint rejects a PATCH from a user without the change permission, so a view-only user
    // gets the card without the edit pencil rather than a modal that cannot save.
    if (!SessionStore.userHasPermission(PERMISSIONS.CHANGE_LOAN_ACCOUNT)) {
      return <Card {...cardProps} />;
    }

    return <EditableCard {...cardProps} onSave={onSave} />;
  }

  public render () {
    return (
      <Grid fluid className='loan-account-detail-tab tab-details'>
        <Row>
          <Col>
            {this.renderAccountInfo()}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default TabDetails;
